import { render, staticRenderFns } from "./SectionMatchSetup.vue?vue&type=template&id=c54dad56&"
import script from "./SectionMatchSetup.vue?vue&type=script&lang=js&"
export * from "./SectionMatchSetup.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports